module.exports = __webpack_public_path__ + "static/media/sample_lmsobzones.0826dd91.csv";